import { staticApis } from "../client";
import { TagList } from "../schemas/tags";

export const { getTags } = staticApis({ getTags: ["GET", "/tags", TagList] });
